import React from 'react';

const Oval = (props) => {
    const { color } = props;

    return (
        <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 835 473"
            style={{ enableBackground: 'new 0 0 835 473', width: '100%' }}
            xmlSpace="preserve"
        >
            <g transform="matrix(1, 0, 0, 1, 0, 0)">
                <ellipse id="Ellipse_131-2" style={{ fill: `${color}` }} cx="417.5" cy="233.5" rx="408.5" ry="227.5" />
            </g>
        </svg>
    );
};

export default Oval;
